<ng-template #popover>
  <alert-content
    (emitterHide)="hide()"
    [title]="showAlert?.type"
    imageName="payments-options-alert.svg"
  ></alert-content>
</ng-template>
<mb-form-field
  [mb-popover]="popover"
  [mbPopoverShow]="false"
  [mbPopoverDismissible]="true"
  mbPopoverColor="light"
  mbPopoverPosition="left"
>
  <select
    class="desktop-options"
    mb-form-field-input
    [(ngModel)]="selectedPaymentMethod"
    (ngModelChange)="applyChange()"
  >
    <option
      value="all"
      selected="true"
      i18n="@@paymentmethodselector_todas_las_formas_de_pago"
    >
      Todas las formas de pago
    </option>
    <option *ngIf="isArgentina" value="PREPAID" i18n="@@pago_en_cuotas">
      Pago en cuotas
    </option>
    <option *ngIf="!isArgentina" value="PREPAID" i18n="@@pago_en_una_cuota">
      Pago en 1 cuota
    </option>
    <option value="PAY_AT_DESTINATION" i18n="@@pago_en_el_destino">
      Pago en el destino
    </option>
  </select>
  <select
    class="mobile-options"
    mb-form-field-input
    [(ngModel)]="selectedPaymentMethod"
    (ngModelChange)="applyChange()"
  >
    <option value="all" selected="true" i18n="@@paymentmethodselector_metodos_de_pago">
      Métodos de pago
    </option>
    <option *ngIf="isArgentina" value="PREPAID" i18n="@@pago_en_cuotas">
      Pago en cuotas
    </option>
    <option *ngIf="!isArgentina" value="PREPAID" i18n="@@pago_en_una_cuota">
      Pago en 1 cuota
    </option>
    <option value="PAY_AT_DESTINATION" i18n="@@pago_en_el_destino">
      Pago en el destino
    </option>
  </select>
</mb-form-field>
